import { Schema, SchemaSettings } from '@orbit/data'
import { KC } from '@/http/utils'
import { DataPoint, InhalerUsage } from '@/jsonapi/CommonTypes'
import { PatientWithEventsEvent } from '@/jsonapi/PatientWithEvents'

enum ModelTypes {
  PatientWithMappingReports = 'patient-with-mapping-report',
}

enum ModelTypeNames {
  PatientWithMappingReports = 'patientWithMappingReport',
}

export enum INHALER_USAGE_TYPE {
  maintenance = 'maintenance',
  reliever = 'reliever',
}

export type SleepingPeriod = {
  sleepingTime: number
  awakeTime: number
}

export type PatientWithMappingReportsAttributes = {
  firstName?: string
  lastName?: string
  timezone?: string
  patientId?: string
  activeDays?: number
  adherenceRate?: number
  avgCasualWalkingStepsPerDay?: number
  avgSleepEfficiency?: number
  avgTotalSleepTime?: number
  avgWalkingDistancePerDay?: number
  avgWalkingDurationPerDay?: number
  awakePeriod?: DataPoint[]
  casualWalkingStepsPerDay: DataPoint[]
  combinedWalkingDistance: DataPoint[]
  combinedWalkingDuration: DataPoint[]
  firstActivity?: number
  lastActivity?: number
  lastInhalerDrift?: number
  majorInterruptions?: DataPoint[]
  numberOfAwakenings?: DataPoint[]
  patientEvents?: DataPoint[]
  // liveEvents?: PatientWithEventsEvent[]
  sleepEfficiencies?: DataPoint[]
  inhalerUsages: InhalerUsage[]
  uncontrolledDays?: number
  sleepStates?: DataPoint[]
  sleepingPeriods: SleepingPeriod[]
  starttimestamp?: number
  endtimestamp?: number
  resultStartTimestamp?: number
  resultEndTimestamp?: number
  totalDays: number
}

export interface PatientWithMappingReportsSchema {
  id: string
  attributes: PatientWithMappingReportsAttributes
}

export interface GetPatientWithMappingReportsByIdDto {
  patientId: string
  startTimestamp: number
  endTimestamp: number
}

const schemaDefinition: SchemaSettings = {
  models: {
    [ModelTypeNames.PatientWithMappingReports]: {
      attributes: {
        firstName: { type: 'string' },
        lastName: { type: 'string' },
        timezone: { type: 'string' },
        patientId: { type: 'string' },
        activeDays: { type: 'number' },
        adherenceRate: { type: 'number' },
        avgCasualWalkingStepsPerDay: { type: 'number' },
        avgTotalSleepTime: { type: 'number' },
        avgSleepEfficiency: { type: 'number' },
        avgWalkingDistancePerDay: { type: 'number' },
        avgWalkingDurationPerDay: { type: 'number' },
        awakePeriod: { type: 'array' },
        casualWalkingStepsPerDay: { type: 'array' },
        combinedWalkingDistance: { type: 'array' },
        combinedWalkingDuration: { type: 'array' },
        firstActivity: { type: 'number' },
        lastActivity: { type: 'number' },
        lastInhalerDrift: { type: 'number' },
        majorInterruptions: { type: 'array' },
        numberOfAwakenings: { type: 'array' },
        patientEvents: { type: 'array' },
        // liveEvents: { type: 'array' },
        sleepEfficiencies: { type: 'array' },
        inhalerUsages: { type: 'array' },
        uncontrolledDays: { type: 'number' },
        sleepStates: { type: 'array' },
        sleepingPeriods: { type: 'array' },
        starttimestamp: { type: 'number' },
        endtimestamp: { type: 'number' },
        resultStartTimestamp: { type: 'number' },
        resultEndTimestamp: { type: 'number' },
        totalDays: { type: 'number' },
      },
    },
  },
}

export async function getPatientWithMappingReportsById(params: GetPatientWithMappingReportsByIdDto) {
  const schema = new Schema(schemaDefinition)
  const remote = await KC.getJsonApiRemoteResource(schema)
  return remote
    .query(q => {
      // console.log('Before calling find record for patient with mapping reports', 'id:', params)
      return q
        .findRecords(ModelTypes.PatientWithMappingReports)
        .filter(
          { attribute: 'id', value: params.patientId },
          { attribute: 'starttimestamp', value: params.startTimestamp },
          { attribute: 'endtimestamp', value: params.endTimestamp }
        )
    })
    .catch(() => {
      console.log('fetch failed in get patient with mapping reports ')
    })
}
